import { createI18n } from 'vue-i18n'

import en from './locales/en.json'
import nl from './locales/nl.json'
import pl from './locales/pl.json'

const STORAGE_KEY = 'aannemerplus_onboarding_locale'
const SUPPORTED = ['en', 'nl', 'pl'] as const

function detectLocale(): string {
  // 1. localStorage
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored && SUPPORTED.includes(stored as any)) return stored

  // 2. Browser language
  const browserLang = navigator.language.split('-')[0]
  if (browserLang && SUPPORTED.includes(browserLang as any)) return browserLang

  // 3. Fallback
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en, nl, pl },
  globalInjection: true
})

/** Persist locale choice to localStorage. */
export function setLocale(locale: string) {
  if (!SUPPORTED.includes(locale as any)) return
  ;(i18n.global.locale as unknown as { value: string }).value = locale
  localStorage.setItem(STORAGE_KEY, locale)
}

export function getLocale(): string {
  return i18n.global.locale.value
}

export { STORAGE_KEY, SUPPORTED }
export default i18n
